import React from "react";
import { Box, Typography } from "@mui/material";

const BlogArticleSection = ({ id, title, html }) => {
  return (
    <Box id={id} sx={{ mb: 6, scrollMarginTop: "96px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
        <Box sx={{ width: 4, alignSelf: "stretch", borderRadius: "999px", backgroundColor: "hsl(153, 68%, 25%)" }} />
        <Typography component="h2" sx={{ fontSize: { xs: "1.5rem", md: "1.875rem" }, lineHeight: { xs: "2rem", md: "2.25rem" }, fontWeight: 700, color: "hsl(150 30% 14%)" }}>
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          fontSize: { md: "1.125rem" },
          lineHeight: 1.8,
          color: "hsl(150 30% 14% / 0.9)",
          "& p": {
            mt: 0,
            mb: 2,
          },
          "& a": {
            color: "hsl(150 37% 17%)",
            fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
            textDecorationColor: "hsl(153, 68%, 25%)",
            textUnderlineOffset: "4px",
            "&:hover": {
              textDecorationThickness: "2px",
            },
          },
          "& strong": {
            fontFamily: "Segoe UI Semibold, system-ui, sans-serif",
          },
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Box>
  );
};

export default BlogArticleSection;
